import React from "react";

import { useI18n } from "utils/with-i18n.utils";

import { BestsComparedCard } from "./BestsComparedCard";

export const BestsComparedSection = () => {
  const i18n = useI18n();

  return (
    <>
      <h2 className="mx-auto w-full max-w-[1200px] text-2xl font-medium text-center lg:text-left">
        {i18n.t("comparator.bestCompared")}
      </h2>

      <section className="grid grid-cols-2 gap-3 mx-auto w-full max-w-[1200px] sm:gap-5 md:grid-cols-4">
        <BestsComparedCard
          leftModel="iPhone 15"
          rightModel="iPhone 15 Pro"
          imageSrc="/images/comparator/match-15-vs-15-pro.webp"
          href="/compare/iphone-15-vs-iphone-15-pro"
        />
        <BestsComparedCard
          leftModel="iPhone 14"
          rightModel="iPhone 15"
          imageSrc="/images/comparator/match-14-vs-15.webp"
          href="/compare/iphone-14-vs-iphone-15"
        />
        <BestsComparedCard
          leftModel="iPhone 14 Pro"
          rightModel="iPhone 15 Pro"
          imageSrc="/images/comparator/match-14-pro-vs-15-pro.webp"
          href="/compare/iphone-14-pro-vs-iphone-15-pro"
        />
        <BestsComparedCard
          leftModel="iPhone 14 Pro Max"
          rightModel="iPhone 15 Pro Max"
          imageSrc="/images/comparator/match-14-pro-max-vs-15-pro-max.webp"
          href="/compare/iphone-14-pro-max-vs-iphone-15-pro-max"
        />
      </section>
    </>
  );
};
